<template>
  <div id="root">
    <div id="app" class="logged-in">
      <div id="app-menu">
        <div id="app-menu-content-wrapper">
          <div id="app-menu-content" :style="'margin-top: 55px'">
            
             <!-- Header Section -->
             <div
               :style="isMobile == true ? 'margin-bottom: 20px;background-color: #6153cc;border-bottom-right-radius: 20px;border-bottom-left-radius: 20px;width:100vw;margin-right: -20px !important;' : 'margin-bottom: 40px;background-color: #6153cc;border-bottom-right-radius: 30px;border-bottom-left-radius: 30px;margin-right: -20px !important;'"
               id="app-menu-content-header">
               <div :style="isMobile == true ? 'margin-top:10px;padding: 15px;width: 100%;' : 'margin-top:10px;padding: 20px;width: 100%;'" class="app-menu-content-header-section">
                 <div style="" class="reminder">
                   <div class="reminder-icon">
                     <i class="fa-solid fa-tools" :style="isMobile == true ? 'font-size: 30px; color: white; margin-left: 8px;' : 'font-size: 40px; color: white; margin-left: 10px;'"></i>
                   </div>
                   <span :style="isMobile == true ? 'font-size: 18px; font-weight: bold;' : 'font-size: 24px; font-weight: bold;'" class="reminder-text">ابزارهای هوش مصنوعی</span>
                 </div>
                 <div class="reminder">
                   <span :style="isMobile == true ? 'margin-top:10px;margin-right:8px;font-size: 13px;color: rgba(255,255,255,0.9);' : 'margin-top:15px;margin-right:10px;font-size: 16px;color: rgba(255,255,255,0.9);'"
                     class="reminder-text">مجموعه‌ای از ابزارهای پیشرفته
                   </span>
                 </div>
               </div>
             </div>

            <!-- Search Section -->
            
                        <!-- Popular Tools Section -->
                        <div id="popular-tools-section" class="menu-section" style="margin-top: 10px;">
              <div style="display:flex;justify-content:space-between">
                <div class="menu-section-title">
                  <i class="fa-solid fa-fire" aria-hidden="true"></i>
                  <span class="menu-section-title-text">ابزارهای محبوب</span>
                </div>
              </div>
              
              <div class="scrollable-container">
                <div class="popular-tools-list">
                  <div 
                    v-for="tool in popularTools" 
                    :key="tool.id" 
                    class="popular-tool-card"
                    @click="openTool(tool)"
                  >
                    <div class="popular-tool-image">
                      <i :class="tool.icon"></i>
                    </div>
                    <div class="popular-tool-info">
                      <h4 class="popular-tool-title">{{ tool.name }}</h4>
                      <p class="popular-tool-desc">{{ tool.shortDescription }}</p>
                      <div class="popular-tool-stats">
                         <div class="popular-tool-rating">
                          <i class="fa-solid fa-star"></i>
                          <span>{{ tool.rating }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="popular-tool-action">
                      <i class="fa-solid fa-arrow-left"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="search-section" class="menu-section" style="margin-bottom: 20px;">
              <div class="search-container">
                <div class="search-input-wrapper">
                  <i class="fa-solid fa-search search-icon"></i>
                  <input 
                    v-model="searchQuery" 
                    type="text" 
                    placeholder="جستجو در ابزارها..." 
                    class="search-input"
                    @input="filterTools"
                  />
                </div>
              </div>
            </div>
            <!-- Categories Section -->
            <div id="categories-section" class="menu-section">
              <div style="display:flex;justify-content:space-between">
                <div class="menu-section-title">
                  <i class="fa-solid fa-layer-group" aria-hidden="true"></i>
                  <span class="menu-section-title-text">دسته‌بندی ابزارها</span>
                </div>
              </div>
              <div class="scrollable-container">
                <div class="category-list">
                  <div 
                    v-for="category in categories" 
                    :key="category.id" 
                    class="category-card"
                    :class="{ active: selectedCategory === category.id }"
                    @click="selectCategory(category.id)"
                  >
                    <div class="category-icon">
                      <i :class="category.icon"></i>
                    </div>
                    <span class="category-name">{{ category.name }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tools Grid Section -->
            <div id="tools-section" class="menu-section">
              <div style="display:flex;justify-content:space-between">
                <div class="menu-section-title">
                  <i class="fa-solid fa-magic-wand-sparkles" aria-hidden="true"></i>
                  <span class="menu-section-title-text">{{ selectedCategoryName }} ابزارها</span>
                </div>
                <div class="menu-section-title">
                  <span class="menu-section-title-text text-button2"
                    style="padding:8px;border-radius:8px;font-weight:200;font-size:0.9em;">
                    {{ filteredTools.length }} ابزار
                  </span>
                </div>
              </div>
              
              <div class="tools-grid">
                <div 
                  v-for="tool in filteredTools" 
                  :key="tool.id" 
                  class="tool-card"
                  @click="openTool(tool)"
                >
                  <div class="tool-card-header">
                    <div class="tool-icon">
                      <i :class="tool.icon"></i>
                    </div>
                    <div class="tool-badge" v-if="tool.isNew">
                      <span>جدید</span>
                    </div>
                  </div>
                  
                  <div class="tool-card-content">
                    <h3 class="tool-title">{{ tool.name }}</h3>
                    <p class="tool-description">{{ tool.description }}</p>
                    
                    <div class="tool-features">
                      <span 
                        v-for="feature in tool.features" 
                        :key="feature" 
                        class="feature-tag"
                      >
                        {{ feature }}
                      </span>
                    </div>
                  </div>
                  
                  <div class="tool-card-footer">
                    <div class="tool-rating" v-if="tool.rating">
                      <i class="fa-solid fa-star"></i>
                      <span>{{ tool.rating }}</span>
                    </div>
                    <div class="tool-action">
                      <i class="fa-solid fa-arrow-left"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
                <br/>
                <br/>
                <br/>
                <br/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import router from '@/router';

export default {
  name: 'ToolsView',
  data() {
    return {
      searchQuery: '',
      selectedCategory: 'all',
      categories: [
        { id: 'all', name: 'همه', icon: 'fa-solid fa-th' },
        { id: 'text', name: 'متن و نوشتار', icon: 'fa-solid fa-file-text' },
        { id: 'image', name: 'تصویر و گرافیک', icon: 'fa-solid fa-image' },
        { id: 'video', name: 'ویدیو و رسانه', icon: 'fa-solid fa-video' },
      ],
      tools: [
        {
          id: 'text-generator',
          name: 'گفتگو با هوش مصنوعی',
          description: 'ایجاد محتوای متنی',
          icon: 'fa-solid fa-pen-fancy',
          category: 'text',
          features: ['متن', 'کپی‌رایتینگ', 'ترجمه'],
          rating: 4.9,
          isNew: false,
          route: '/chat'
        },
        {
          id: 'image-editor',
          name: 'ادیت تصویر',
          description: 'ویرایش و بهبود تصاویر با استفاده از هوش مصنوعی',
          icon: 'fa-solid fa-paintbrush',
          category: 'image',
          features: ['ویرایش خودکار', 'فیلترها', 'بهبود کیفیت'],
          rating: 4.9,
          isNew: true,
          route: '/editimage'
        },
        {
          id: 'video-creator',
          name: 'ساخت ویدیو',
          description: 'ایجاد ویدیوهای جذاب از متن',
          icon: 'fa-solid fa-film',
          category: 'video',
          features: ['ویدیو', 'ساخت'],
          rating: 4.7,
          isNew: true,
          route: '/videogeneration'
        },
        {
          id: 'image-editor',
          name: 'روبو ویژن',
          description: 'پاسخ دادن به عکس، حل کردن مسائل، تشخیص وسایل و ...',
          icon: 'fa-solid fa-eye',
          category: 'image',
          features: ['ویژن', 'متن', 'سوال'],
          rating: 4.6,
          isNew: false,
          route: '/imageanswering'
        },
        {
          id: 'code-assistant',
          name: 'دستیار برنامه نویسی',
          description: 'کمک در نوشتن، دیباگ و بهینه‌سازی کد در زبان‌های مختلف',
          icon: 'fa-solid fa-terminal',
          category: 'text',
          features: ['Python', 'JavaScript', 'Java'],
          rating: 4.9,
          isNew: false,
          route: '/chat?id=code'
        },
        {
          id: 'language-tutor',
          name: 'معلم زبان',
          description: 'یادگیری زبان‌های مختلف با تمرینات تعاملی و بازخورد فوری',
          icon: 'fa-solid fa-language',
          category: 'text',
          features: ['انگلیسی', 'فرانسوی', 'آلمانی'],
          rating: 4.8,
          isNew: false,
          route: '/chat?id=translate'
        },
        {
          id: 'content-planner',
          name: 'تولید محتوا',
          description: 'برنامه‌ریزی و ساخت و زمان‌بندی انتشار محتوا در شبکه‌های اجتماعی',
          icon: 'fa-solid fa-calendar-check',
          category: 'text',
          features: ['زمان‌بندی', 'شبکه‌های اجتماعی', 'تحلیل'],
          rating: 4.6,
          isNew: false,
          route: '/chat?id=karshenasmohtava'
        }
      ],
      popularTools: [

        {
          id: 'image-editor',
          name: 'ادیت تصویر',
          shortDescription: 'ویرایش و بهبود تصاویر',
          icon: 'fa-solid fa-paintbrush',
          usageCount: '100K',
          rating: 4.9,
          route: '/editimage'
        },
        {
          id: 'video-creator',
          name: 'ساخت ویدیو',
          shortDescription: 'ایجاد ویدیوهای جذاب',
          icon: 'fa-solid fa-film',
          usageCount: '6.7K',
          rating: 4.7,
          route: '/videogeneration'
        }
      ],
      isMobile: navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i) ? true : false,
    };
  },
  computed: {
    selectedCategoryName() {
      const category = this.categories.find(cat => cat.id === this.selectedCategory);
      return category ? category.name : 'همه';
    },
    filteredTools() {
      let filtered = this.tools;
      
      // Filter by category
      if (this.selectedCategory !== 'all') {
        filtered = filtered.filter(tool => tool.category === this.selectedCategory);
      }
      
      // Filter by search query
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(tool => 
          tool.name.toLowerCase().includes(query) ||
          tool.description.toLowerCase().includes(query) ||
          tool.features.some(feature => feature.toLowerCase().includes(query))
        );
      }
      
      return filtered;
    }
  },
  methods: {
    selectCategory(categoryId) {
      this.selectedCategory = categoryId;
    },
    filterTools() {
      // This method is called when search input changes
      // The filtering is handled by the computed property
    },
    openTool(tool) {
      // For now, we'll show an alert. In a real app, you'd navigate to the tool
      router.push(tool.route)
      // router.push(tool.route);
    }
  },
  mounted() {
    // Initialize any necessary setup
    var that = this;
    var elements = document.getElementById("topnav");
    if (elements != null && this.isMobile == true) {
      elements.style.backgroundColor = "#6153cc";
      var color = false;
      var path = this.$route.path;
      const onScroll = () => {
        const {
          scrollTop,
          scrollHeight,
          clientHeight
        } = document.documentElement;
        if (that.$route.path != path) {
          elements.style.backgroundColor = "#212529";
          window.removeEventListener('scroll', onScroll);
          return;
        }
        if (scrollTop > 110 && color == false) {
          elements.style.backgroundColor = "#212529";
          color = true;
        }
        else if (scrollTop <= 110 && color == true) {
          elements.style.backgroundColor = "#6153cc";
          color = false;
        }
      };
      window.addEventListener('scroll', onScroll, {
        passive: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

span {
  font-family: IRANSansWeb;
  font-weight: bold;
}

@function gray($color) {
  @return rgb($color, $color, $color);
}

$red: rgb(239, 83, 80);
$orange: rgb(255, 160, 0);
$yellow: rgb(253, 216, 53);
$green: rgb(42, 252, 152);
$indigo: rgb(57, 73, 171);
$violet: rgb(103, 58, 183);
$blue: rgb(66, 165, 245);

body {
  margin: 0px;
  overflow-x: hidden;
  padding: 0px;
  background-color: gray(30);

  input,
  h1,
  h3,
  a,
  span {
    font-family: IRANSansWeb;
    font-weight: bold;
    font-weight: 400;
    margin: 0px;
    padding: 0px;
  }
}

#app {
  background-color: gray(30);

  &.logged-in {
    #app-menu {
      opacity: 1;
      pointer-events: all;
    }
  }

  #app-menu {
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
    position: relative;
    transition: opacity 250ms, transform 250ms;
    z-index: 2;

    #app-menu-content-wrapper {
      background: #212529;
      min-height: 80vh;
      padding: 20px;
      padding-top: 0px;

      #app-menu-content {
        margin: auto;
        max-width: 1600px;
        position: relative;
      }
    }

    // Tablet and Desktop adjustments
    @media (min-width: 768px) {
      #app-menu-content-wrapper {
        padding: 80px;
        padding-top: 0px;
      }
    }
  }

  .menu-section {

    .menu-section-title {
      align-items: center;
      display: flex;
      gap: 6px;

      i,
      span {
        color: gray(245);
      }

      i {
        font-size: 1em;
      }

      .menu-section-title-text {
        color: rgba(white, 0.9);
        font-size: 1.2em;
        font-weight: bold;
      }
    }

    .menu-section-content {
      margin-top: 15px;
      padding-top: 5px;
    }
  }

  // Tablet and Desktop adjustments
  @media (min-width: 768px) {
    .menu-section {
      margin-top: 40px;

      .menu-section-title {
        .menu-section-title-text {
          font-size: 1.4em;
        }
      }
    }
  }

  .text-button2 {
    background-color: rgba(white, 0.1);
  }

  .reminder {
    display: flex;
    gap: 6px;
    margin-top: 10px;
    width: 100%;

    i,
    div {
      display: inline-flex;
    }

    i {
      color: gray(245);
      font-size: 0.8em;
      height: 12px;
      line-height: 12px;
    }

    span {
      color: rgba(white, 0.8);
      font-size: 1.1em;
    }

    .reminder-icon {
      align-items: center;
      height: 20px;
    }
  }
}

// Search Section Styles
.search-container {
}

// Categories Section Styles
.scrollable-container {
  width: 100%;
  overflow-x: auto;
  padding: 20px 0;
  cursor: grab;
  user-select: none;

  &:active {
    cursor: grabbing;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
}

.category-list {
  display: flex;
  gap: 15px;
  width: max-content;
}

// Popular Tools Section Styles
.popular-tools-list {
  display: flex;
  gap: 15px;
  width: max-content;
}

// Mobile-First Responsive Design
// Base styles are for mobile (320px+)

// Mobile styles (default)
.tools-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  margin-top: 20px;
}

.tool-card {
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.2);
  border-radius: 15px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    background-color: rgba(white, 0.15);
    border-color: #6153cc;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(97, 83, 204, 0.2);
  }

  .tool-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;

    .tool-icon {
      width: 45px;
      height: 45px;
      background: linear-gradient(135deg, #6153cc, #8b7ed8);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 20px;
        color: white;
      }
    }

    .tool-badge {
      background-color: #ff6b6b;
      color: white;
      padding: 3px 6px;
      border-radius: 8px;
      font-size: 10px;
      font-weight: bold;
    }
  }

  .tool-card-content {
    margin-bottom: 12px;

    .tool-title {
      color: white;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 6px;
      font-family: IRANSansWeb;
      line-height: 1.3;
    }

    .tool-description {
      color: rgba(white, 0.7);
      font-size: 13px;
      line-height: 1.4;
      margin-bottom: 10px;
      font-family: IRANSansWeb;
    }

    .tool-features {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;

      .feature-tag {
        background-color:#6153cc;
        color: white;
        padding: 3px 6px;
        border-radius: 6px;
        font-size: 10px;
        font-weight: bold;
      }
    }
  }

  .tool-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tool-rating {
      display: flex;
      align-items: center;
      gap: 3px;
      color: #ffd700;

      i {
        font-size: 12px;
      }

      span {
        font-size: 12px;
        font-weight: bold;
        margin-top: 2px;
      }
    }

    .tool-action {
      color: #6153cc;
      font-size: 14px;
    }
  }
}

.category-card {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 15px;
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.2);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 90px;

  &:hover {
    background-color: rgba(white, 0.15);
    transform: translateY(-2px);
  }

  &.active {
    background-color: #6153cc;
    border-color: #6153cc;
    transform: translateY(-2px);
  }

  .category-icon {
    margin-bottom: 6px;
    
    i {
      font-size: 18px;
      color: white;
    }
  }

  .category-name {
    color: white;
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    line-height: 1.2;
  }
}

.popular-tool-card {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.2);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;

  &:hover {
    background-color: rgba(white, 0.15);
    transform: translateY(-2px);
  }

  .popular-tool-image {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #6153cc, #8b7ed8);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 12px;

    i {
      font-size: 16px;
      color: white;
    }
  }

  .popular-tool-info {
    flex: 1;

    .popular-tool-title {
      color: white;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 3px;
      font-family: IRANSansWeb;
      line-height: 1.2;
    }

    .popular-tool-desc {
      color: rgba(white, 0.7);
      font-size: 11px;
      margin-bottom: 6px;
      font-family: IRANSansWeb;
      line-height: 1.3;
    }

    .popular-tool-stats {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .usage-count {
        color: rgba(white, 0.6);
        font-size: 10px;
      }

      .popular-tool-rating {
        display: flex;
        align-items: center;
        gap: 3px;
        color: #ffd700;

        i {
          font-size: 10px;
        }

        span {
          font-size: 10px;
          font-weight: bold;
          margin-top:2px
        }
      }
    }
  }

  .popular-tool-action {
    color: #6153cc;
    font-size: 12px;
  }
}

.search-input-wrapper {
  position: relative;
  max-width: 100%;
  margin: 0 auto;
}

.search-input {
  width: 100%;
  padding: 12px 45px 12px 15px;
  background-color: rgba(white, 0.1);
  border: 1px solid rgba(white, 0.2);
  border-radius: 20px;
  color: white;
  font-family: IRANSansWeb;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;

  &::placeholder {
    color: rgba(white, 0.5);
  }

  &:focus {
    border-color: #6153cc;
    background-color: rgba(white, 0.15);
    box-shadow: 0 0 0 2px rgba(97, 83, 204, 0.1);
  }
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(white, 0.5);
  font-size: 14px;
}

// Tablet styles (768px+)
@media (min-width: 768px) {
  .tools-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
  }

  .tool-card {
    padding: 20px;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(97, 83, 204, 0.2);
    }

    .tool-card-header {
      margin-bottom: 15px;

      .tool-icon {
        width: 50px;
        height: 50px;
        border-radius: 12px;

        i {
          font-size: 24px;
        }
      }

      .tool-badge {
        padding: 4px 8px;
        border-radius: 12px;
        font-size: 12px;
      }
    }

    .tool-card-content {
      margin-bottom: 15px;

      .tool-title {
        font-size: 18px;
        margin-bottom: 8px;
      }

      .tool-description {
        font-size: 14px;
        margin-bottom: 12px;
      }

      .tool-features {
        gap: 6px;

        .feature-tag {
          padding: 4px 8px;
          border-radius: 8px;
          font-size: 12px;
        }
      }
    }

    .tool-card-footer {
      .tool-rating {
        gap: 4px;

        i {
          font-size: 14px;
        }

        span {
          font-size: 14px;
        }
      }

      .tool-action {
        font-size: 16px;
      }
    }
  }

  .category-card {
    padding: 15px 20px;
    min-width: 120px;

    .category-icon {
      margin-bottom: 8px;
      
      i {
        font-size: 24px;
      }
    }

    .category-name {
      font-size: 14px;
    }
  }

  .popular-tool-card {
    padding: 15px;
    min-width: 280px;

    .popular-tool-image {
      width: 50px;
      height: 50px;
      border-radius: 10px;
      margin-left: 15px;

      i {
        font-size: 20px;
      }
    }

    .popular-tool-info {
      .popular-tool-title {
        font-size: 16px;
        margin-bottom: 4px;
      }

      .popular-tool-desc {
        font-size: 13px;
        margin-bottom: 8px;
      }

      .popular-tool-stats {
        .usage-count {
          font-size: 12px;
        }

        .popular-tool-rating {
          gap: 4px;

          i {
            font-size: 12px;
          }

          span {
            font-size: 12px;
          }
        }
      }
    }

    .popular-tool-action {
      font-size: 14px;
    }
  }

  .search-input-wrapper {
    max-width: 500px;
  }

  .search-input {
    padding: 15px 50px 15px 20px;
    font-size: 16px;
    border-radius: 25px;
  }

  .search-icon {
    right: 15px;
    font-size: 16px;
  }
}

// Desktop styles (1024px+)
@media (min-width: 1024px) {
  .tools-grid {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

// Extra small mobile devices (320px and below)
@media (max-width: 320px) {
  .category-card {
    min-width: 75px;
    padding: 8px 10px;

    .category-icon i {
      font-size: 16px;
    }

    .category-name {
      font-size: 10px;
    }
  }

  .popular-tool-card {
    min-width: 180px;
    padding: 10px;

    .popular-tool-image {
      width: 35px;
      height: 35px;
      margin-left: 10px;

      i {
        font-size: 14px;
      }
    }

    .popular-tool-info {
      .popular-tool-title {
        font-size: 13px;
      }

      .popular-tool-desc {
        font-size: 10px;
      }
    }
  }

  .tool-card {
    padding: 12px;

    .tool-card-header {
      .tool-icon {
        width: 40px;
        height: 40px;

        i {
          font-size: 18px;
        }
      }
    }

    .tool-card-content {
      .tool-title {
        font-size: 15px;
      }

      .tool-description {
        font-size: 12px;
      }
    }
  }
}
</style>
